import { z } from 'zod';
import { billingUsageSummarySchema } from './billingUsage';

export const dashboardUsagePayloadSchema = z.object({
  usage: billingUsageSummarySchema,
  includedMinutes: z.number().int().nonnegative(),
  usedMinutes: z.number().int().nonnegative(),
  overageMinutes: z.number().int().nonnegative(),
  estimatedOverageMinutes: z.number().int().nonnegative(),
  cycleStart: z.string().datetime(),
  cycleEnd: z.string().datetime(),
  sessionsBillable: z.number().int().nonnegative(),
  sessionsNonBillable: z.number().int().nonnegative(),
  incrementsUsed: z.number().int().nonnegative(),
  incrementsIncluded: z.number().int().nonnegative(),
  overageIncrements: z.number().int().nonnegative(),
});
export type DashboardUsagePayload = z.infer<typeof dashboardUsagePayloadSchema>;
